import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AbsenceModal from "./AbsenceModal";
import Swal from "sweetalert2";
import { api } from "../api";

export default function StudentList({
  students,
  onRefresh,
  page = 1,
  totalPages = 1,
  onPageChange
}) {

  const navigate = useNavigate();
  const [selectedStudent, setSelectedStudent] = useState(null);

  async function resolveRisk(student) {
    const confirm = await Swal.fire({
      title: "Resolver caso?",
      text: "Marcar como resolvido pelo instrutor?",
      icon: "question",
      showCancelButton: true,
    });

    if (!confirm.isConfirmed) return;

    try {
      const followUpsResponse = await api.get(`/followups/student/${student.id}`);
      const activeFollowUp = (followUpsResponse.data || []).find(
        (item) => item.status === "IN_PROGRESS"
      );

      if (!activeFollowUp) {
        await Swal.fire("Nenhum acompanhamento ativo encontrado.");
        return;
      }

      await api.put(`/followups/resolve/${activeFollowUp.id}`, {
        resolvedBy: "INSTRUCTOR",
      });

      await Swal.fire("Resolvido", "Caso marcado como resolvido.", "success");
      if (onRefresh) {
        onRefresh();
      }
    } catch (error) {
      await Swal.fire(
        "Erro",
        error.response?.data?.error || "NÃ£o foi possÃ­vel resolver o caso.",
        "error"
      );
    }
  }

  return (
    <div>

      {students.map((student) => (
        <div key={student.id} className="card mb-3 shadow-sm">

          <div className="card-body d-flex justify-content-between align-items-center">

            <div>
              <h6 className="mb-1">{student.name}</h6>

              {student.riskFlag && (
                <span className="badge bg-danger">
                  Em Risco
                </span>
              )}
            </div>

            <div className="d-flex gap-2">

            <button
                  className="btn btn-outline-primary btn-sm"
                  onClick={() =>
                  navigate(`/students/${student.id}/absences`, {
                  state: { studentName: student.name }
                })
                }
>
  Ver Faltas
</button>


              <button
                className="btn btn-primary btn-sm"
                onClick={() => setSelectedStudent(student)}
              >
                Lançar Falta
              </button>

              {student.riskFlag && (
                <button
                  className="btn btn-outline-success btn-sm"
                  onClick={() => resolveRisk(student)}
                >
                  Aluno Retornou
                </button>
              )}

            </div>

          </div>
        </div>
      ))}

      {selectedStudent && (
        <AbsenceModal
          student={selectedStudent}
          onClose={() => setSelectedStudent(null)}
        />
      )}

      {onPageChange && (
        <div className="d-flex justify-content-center align-items-center mt-3">
          <button
            className="btn btn-outline-secondary me-3"
            disabled={page <= 1}
            onClick={() => onPageChange(page - 1)}
          >
            Anterior
          </button>

          <span>
            Página {page} de {totalPages}
          </span>

          <button
            className="btn btn-outline-secondary ms-3"
            disabled={page >= totalPages}
            onClick={() => onPageChange(page + 1)}
          >
            Próxima
          </button>
        </div>
      )}

    </div>
  );
}
